import { modifier } from 'ember-modifier';

function scrollToIfActive(element: HTMLElement, [isActive]: [boolean]) {
  if (isActive) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

export default modifier(scrollToIfActive);
